import React, { useState, useEffect } from 'react';
import { Card, CardBody, Col, Container, Form, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import 'react-quill/dist/quill.snow.css';
import UiContent from '../../Components/Common/UiContent';
import classnames from "classnames";
import { useParams } from 'react-router-dom';
import { getReport, updateReport } from '../../slices/thunks';
import { useDispatch, useSelector } from 'react-redux';
import PageContentRenderer from '../Report/BuildReport/Components/PageContentRenderer';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import OHr from '../../Components/OElements/OHr';
import PDFReport from './PDFReport';

const ReportView = () => {
    const breadcrumbLinks = [
        { to: '#', label: 'Inicio' },
        { to: '#', label: 'Finanzas' },
        { to: '#', label: 'Reportes' },
    ];

    const { id } = useParams();
    const dispatch = useDispatch();

    const [localReportDetail, setLocalReportDetail] = useState(null);
    const [reportFinal, setLocalReportFinal] = useState(null);
    const [date_ini, setDateIni] = useState(null);
    const [date_end, setDateEnd] = useState(null);
    const [period, setPeriod] = useState(null);
    const [nameReport, setNameReport] = useState(null);
    const { itemReportDetail, isLoadingList } = useSelector(state => ({
        itemReportDetail: state.Report.itemReportDetail,
        isLoadingList: state.Report.isLoadingList
    }));

    useEffect(() => {
        if (!localReportDetail) {
            dispatch(getReport(id));
        }
    }, [dispatch, id, localReportDetail]);

    useEffect(() => {
        if (itemReportDetail) {
            setNameReport(itemReportDetail.name + (itemReportDetail.period ? ' ' + itemReportDetail.period : ''));
        }
    }, [itemReportDetail]);

    useEffect(() => {
        if (itemReportDetail) {
            setLocalReportDetail(itemReportDetail);
            setDateIni(itemReportDetail.date_ini);
            setDateEnd(itemReportDetail.date_end);
            setPeriod(itemReportDetail.period);
            setLocalReportFinal(itemReportDetail)
        }
    }, [itemReportDetail]);

    const [isInteractive, setIsInteractive] = useState(true);
    const [activeTab, setActiveTab] = useState(0);
    const [hasPendingChanges, setHasPendingChanges] = useState(false);

    const handleGenerateReport = () => {
        console.log("Generating report...");
        setIsInteractive(false);
        setTimeout(() => {
            setIsInteractive(true);
        }, 0);
    };

    const toggleTab = (index) => {
        setActiveTab(index);
        // Reinicia el estado de los gráficos para la nueva pestaña
        setChartsStatus({});
        setTabsRenderStatus(prevStatus => ({
            ...prevStatus,
            [index]: false,
        }));
    };

    // const handleDynamicChange = async (pageIndex, field, value, page) => {
    //     if (localReportDetail) {
    //         const updatedPages = localReportDetail.pages.map((p) => {
    //             if (p.page_id === page.page_id) {
    //                 return {
    //                     ...p,
    //                     elements: p.elements.map((el, elIndex) => {
    //                         if (elIndex === 0) {
    //                             return {
    //                                 ...el,
    //                                 [field]: value,
    //                             };
    //                         }
    //                         return el;
    //                     }),
    //                 };
    //             }
    //             return p;
    //         });

    //         setLocalReportDetail(prevState => ({
    //             ...prevState,
    //             pages: [...updatedPages],
    //         }));
    //         setHasPendingChanges(true);
    //     }
    // };

    const handleDynamicChange = async (page_id, field, value) => {
        if (localReportDetail) {

            setHasPendingChanges(true);
        }
    };

    const handleUpdateReport = async () => {
        console.log("Updating report...");
        if (localReportDetail) {
            console.log(localReportDetail)
            await dispatch(updateReport(localReportDetail));
            setHasPendingChanges(false);
        }
    };

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {},
        validationSchema: Yup.object({
            graph: Yup.string().nullable(),
        }),
        validateOnChange: true,
        onSubmit: async values => {
            const PageData = {
                name: values.name,
                page_type_id: values.page_type_id,
                description: values.description,
                elements: Array.isArray(dynamicElements) ? dynamicElements : [dynamicElements],
                ...(isEdit && { _id: dataPage._id }),
            };

            if (isEdit) {
                console.log("Updating page:", PageData);
                await dispatch(updatePage(PageData));
            } else {
                console.log("Adding new page:", PageData);
                await dispatch(addNewPage(PageData));
            }
        },
    });

    const [chartsStatus, setChartsStatus] = useState({});
    const [tabsRenderStatus, setTabsRenderStatus] = useState({});

    useEffect(() => {
        // Chequea si todos los gráficos de la pestaña activa han sido marcados como listos
        const allReady = Object.values(chartsStatus).every(status => status === true);
        if (allReady) {
            setTabsRenderStatus(prevStatus => ({
                ...prevStatus,
                [activeTab]: true,
            }));
        } else {
            setTabsRenderStatus(prevStatus => ({
                ...prevStatus,
                [activeTab]: false,
            }));
        }
    }, [chartsStatus, activeTab]);

    const handleChartReady = (chartId) => {
        setChartsStatus(prevStatus => ({
            ...prevStatus,
            [chartId]: true,
        }));
    };

    return (
        <React.Fragment>
            <UiContent />
            <div className='page-content'>
                <Container fluid>
                    <BreadCrumb title={`Reporte: ${localReportDetail?.name}`} links={breadcrumbLinks} />

                    <Form className='tablelist-form' onSubmit={e => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                    }}>
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody className="form-steps">
                                        <form className="vertical-navs-step">
                                            <Row className="gy-5">
                                                <Col lg={2}>
                                                    <Row>
                                                        <Col lg={12}>
                                                            <div className="d-grid gap-2" >
                                                                {hasPendingChanges && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-secondary w-100"
                                                                        onClick={handleUpdateReport}
                                                                    >
                                                                        <i className="ri-save-line me-1 align-bottom"></i>
                                                                        Guardar Cambios
                                                                    </button>
                                                                )}
                                                                {!hasPendingChanges && tabsRenderStatus[activeTab] && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary w-100"
                                                                        onClick={handleGenerateReport}
                                                                    >
                                                                        <i className={`${Icons.reports} me-1 align-bottom`}></i>
                                                                        Generar reporte
                                                                    </button>
                                                                )}

                                                                <PDFReport id={id} name={nameReport} />

                                                            </div>
                                                        </Col>
                                                        <Col lg={12}>
                                                            <OHr text={'Páginas del reporte'} />
                                                            <Nav className="flex-column custom-nav nav-pills">
                                                                {localReportDetail && localReportDetail.pages.map((page, index) => (
                                                                    <NavItem key={index}>
                                                                        <NavLink
                                                                            href="#"
                                                                            className={classnames({ active: activeTab === index })}
                                                                            onClick={() => toggleTab(index)}
                                                                        >

                                                                            {tabsRenderStatus[index] ? (
                                                                                <span className="badge bg-success m-1">ok</span>
                                                                            ) : (
                                                                                <span className="badge bg-warning m-1">Cargando... </span>
                                                                            )}
                                                                            P{index + 1} - {page.name}
                                                                            <span className='text-muted p-0 m-0'> {page?.page_type.name} </span>
                                                                        </NavLink>
                                                                    </NavItem>
                                                                ))}
                                                            </Nav>
                                                        </Col>
                                                    </Row>

                                                </Col>
                                                <Col lg={8}>
                                                    <div className="px-lg-4">
                                                        <TabContent activeTab={activeTab}>
                                                            {localReportDetail && localReportDetail.pages.map((page, index) => (
                                                                <TabPane tabId={index} key={index}>
                                                                    <PageContentRenderer
                                                                        page={page}
                                                                        pageType={page.page_type.code}
                                                                        elements={page.elements}
                                                                        handleDynamicChange={handleDynamicChange}
                                                                        validation={validation}
                                                                        edit={false}
                                                                        date_ini={date_ini}
                                                                        date_end={date_end}
                                                                        period={period}
                                                                        report={reportFinal}
                                                                        setLocalReportFinal={setLocalReportFinal}
                                                                        onChartReady={handleChartReady}
                                                                    />
                                                                </TabPane>
                                                            ))}
                                                        </TabContent>
                                                    </div>
                                                </Col>
                                                <Col lg={2}>
                                                    <OHr text={'Información adicional'} />
                                                    <p>No hay información adicional para esta página</p>
                                                </Col>
                                            </Row>
                                        </form>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default ReportView;
